<template>
  <v-row>
    <v-col>
      <v-container>
        <v-row>
          <v-col>
            <v-toolbar
              flat
              v-if="selectedCategoriasFinal.length"
              color="white darken-4"
              light
            >
              <v-toolbar-title>
                <div :style="'font-size: 17px'">
                  {{
                    selectedCategoriasFinal.length === 1
                      ? "1 seleccionado"
                      : `${selectedCategoriasFinal.length} seleccionados`
                  }}
                </div>
              </v-toolbar-title>
              <v-divider class="ml-2" vertical></v-divider>
              <v-btn
                :disabled="selectedCategoriasFinal.length < 2"
                text
                @click="setUnificarCategoria"
                v-if="!isUnificar"
              >
                Unificar
              </v-btn>
              <v-btn
                :disabled="selectedCategoriasFinal.length > 1"
                text
                @click="setEditarCategoria(selectedCategoriasFinal[0])"
                v-if="!isEdit"
              >
                Editar
              </v-btn>
              <v-btn
                :disabled="selectedCategoriasFinal.length > 1"
                text
                @click="setEliminarCategoria(selectedCategoriasFinal[0])"
                v-if="!isUnificar"
              >
                Eliminar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="removeCategoria()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>
        </v-row>
        <v-card v-if="isEdit && categoriaEditSelected">
          <producto-categoria-update
            :categoria="categoriaEditSelected"
            @refresh-categorias="refreshCategoriaEditada"
            @cerrar-dialog="isEdit = false"
          ></producto-categoria-update>
        </v-card>
        <v-dialog v-if="categoriaEditSelected" v-model="isDelete" width="550">
          <v-card flat class="pa-4" color="#282828" elevation="2">
            <v-card-title class="text-h6 d-flex align-center">
              ¿Quieres borrar esta categoría permanentemente?
            </v-card-title>

            <v-card-text class="text-center mt-6">
              <v-list-item
                color="grey"
                class="justify-center"
                style="
                  background-color: rgba(255, 255, 255, 0.05);
                  border: 1px solid rgba(255, 255, 255, 0.1);
                "
              >
                <v-list-item-avatar>
                  <v-icon size="40">mdi-folder-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ categoriaEditSelected.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Checkbox de confirmación -->
              <v-checkbox
                v-model="confirmDelete"
                class="mt-6"
                color="grey lighten-1"
                label="Comprendo que borrar esta categoría es una acción que no se puede deshacer"
                hide-details
              />
            </v-card-text>

            <v-card-actions class="mt-6">
              <v-spacer></v-spacer>
              <v-btn rounded variant="text" @click="isDelete = false">
                Cancelar
              </v-btn>
              <v-btn
                rounded
                :disabled="!confirmDelete"
                :light="confirmDelete"
                @click="eliminarCategoria(categoriaEditSelected)"
              >
                Eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card color="#161616" flat v-if="isUnificar">
          <v-container>
            <v-card-title>
              <div class="mt-2">Unificar categorías</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                class="mt-4"
                v-model="nuevoNombreCategoria"
                v-validate="'required'"
                name="nombre de categoría"
                label="Nuevo nombre de categoría"
                outlined
                dense
                clearable
                :error-messages="errors.collect('nuevoNombreCategoria')"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                :disabled="errors.any() || !nuevoNombreCategoria"
                @click="validateForm"
              >
                Unificar
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
        <v-divider></v-divider>

        <v-row
          class="scroll-bar align-stretch d-flex flex-row flex-nowrap mt-2"
          ref="scrollContainer"
        >
          <v-col
            cols="4"
            v-for="comp in categoriasRenderizadas"
            :key="comp.categoria.id"
          >
            <span id="scrollFinal"></span>
            <component
              @processCategoria="fetchCategoria"
              :selectedCategoriasFinal="selectedCategoriasFinal"
              @update:selectedCategoriasFinal="seleccionarCategoria"
              :parent="comp.categoria"
              :is="comp.type"
              :ref="'categoriaNivel' + comp.categoria.level_padre"
            ></component>
          </v-col>
          <!-- Skeleton Loader para carga -->
          <v-col v-if="loadingCategoriaSelected" cols="4">
            <v-skeleton-loader
              type="list-item-two-line"
              class="mb-2"
              v-for="n in 6"
              :key="n"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import ProductoCategoriasTreeBranch from "@/components/producto/categorias/ProductoCategoriasTreeBranch.vue";
import ProductoCategoriaUpdate from "@/components/producto/categorias/ProductoCategoriaUpdate";

import CategoriaAPI from "@/api/categorias";
import ProductosApi from "@/api/productos";

export default {
  name: "",
  components: {
    ProductoCategoriasTreeBranch,
    ProductoCategoriaUpdate,
  },
  $_veeValidate: {
    validator: "new",
  },
  data() {
    return {
      selectedCategoriasFinal: [],
      categoriaPadre: [],
      categoriasRenderizadas: [],
      loadingCategoriaSelected: false,
      count: 0,
      isUnificar: false,
      nuevoNombreCategoria: "",
      isEdit: false,
      isDelete: false,
      confirmDelete: false,
      categoriaEditSelected: null,
    };
  },

  methods: {
    seleccionarCategoria(nuevoArrayCategorias) {
      if (nuevoArrayCategorias.length === 0) {
        this.selectedCategoriasFinal = [];
        return;
      }

      // Tomamos el nivel base de la primera categoría (la "correcta")
      const nivelBase = nuevoArrayCategorias[0].mptt_level;

      // Filtramos para quedarnos solo con las categorías del nivel base
      const filtradas = nuevoArrayCategorias.filter(
        (cat) => cat.mptt_level === nivelBase
      );

      if (filtradas.length < nuevoArrayCategorias.length) {
        // Había categorías fuera del nivel, avisamos
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "info",
          text: "Solo podés elegir categorías del mismo tipo. Corregimos tu selección.",
          timeout: 3000,
        });
      }

      // Actualizamos solo con las categorías válidas
      this.selectedCategoriasFinal = filtradas;
    },
    setEditarCategoria(categoria) {
      if (!this.isEdit) {
        // Hacer una copia profunda para evitar modificar el objeto original
        this.categoriaEditSelected = categoria
          ? JSON.parse(JSON.stringify(categoria))
          : null;
      } else {
        this.categoriaEditSelected = null;
      }
      this.isEdit = !this.isEdit;
    },
    setEliminarCategoria(categoria) {
      if (!this.isDelete) {
        // Hacer una copia profunda para evitar modificar el objeto original
        this.categoriaEditSelected = categoria
          ? JSON.parse(JSON.stringify(categoria))
          : null;
      } else {
        this.categoriaEditSelected = null;
      }
      this.isDelete = !this.isDelete;
    },

    setUnificarCategoria() {
      this.isUnificar = !this.isUnificar;
      if (this.isUnificar) {
        this.nuevoNombreCategoria = this.selectedCategoriasFinal[0].name;
      }
    },
    refreshCategoriaEditada(categoria) {
      // Limpiamos la selección actual de categorías editadas
      this.categoriaEditSelected = [];
      this.selectedCategoriasFinal = [];

      console.log(categoria);

      // Construimos dinámicamente el nombre de la referencia del componente que representa el nivel del padre de la categoría editada
      // Esto es importante porque queremos refrescar el nivel correspondiente en el árbol visual de categorías
      const refName = "categoriaNivel" + categoria.parent_level;

      // Usamos $nextTick para asegurarnos de que la vista haya terminado de renderizar cualquier cambio antes de intentar acceder a los refs
      this.$nextTick(() => {
        // Obtenemos el componente hijo (o hijos) correspondiente a ese nivel
        const cmpHijo = this.$refs[refName];

        // Si hay múltiples componentes con la misma ref (por ejemplo, por v-for), recorremos el array y llamamos al método fetchCategoria en cada uno
        if (Array.isArray(cmpHijo)) {
          cmpHijo.forEach((ref, idx) => {
            ref?.fetchCategoria?.(); // Refrescamos las categorías del nivel correspondiente
          });
        } else {
          // Si es un solo componente, llamamos directamente a fetchCategoria
          cmpHijo?.fetchCategoria?.();
        }
      });
    },
    refreshCategorias() {
      this.categoriaEditSelected = [];
      this.selectedCategoriasFinal = [];
      this.categoriasRenderizadas = [];
    },
    validateForm() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.procesarUnificacion();
        } else {
          this.$validator.validate();
        }
      });
    },
    eliminarCategoria(categoria) {
      this.axios.delete(`/categorias/${categoria.id}`).then((response) => {
        this.isDelete = false;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Categoría eliminada",
          icon: "mdi-check",
          timeout: 3000,
        });
        this.refreshCategoriaEditada(categoria);
      });
    },
    procesarUnificacion() {
      const payload = {
        categoria_ids: this.selectedCategoriasFinal.map((c) => c.id),
        nuevo_nombre: this.nuevoNombreCategoria,
      };

      CategoriaAPI.unificar(payload)
        .then((response) => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Categorías unificadas",
            icon: "mdi-check",
            timeout: 3000,
          });

          // Opcional: limpiar campos, cerrar diálogos, refrescar categorías
          this.nuevoNombreCategoria = "";
          this.selectedCategoriasFinal = [];
          this.isUnificar = false;
          this.fetchCategoria();
        })
        .catch((error) => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "red",
            text:
              error.response?.data?.detail || "Error al unificar categorías",
            icon: "mdi-alert-circle",
            timeout: 3000,
          });
        });
    },

    removeCategoria(categoria) {
      this.selectedCategoriasFinal = [];
    },

    fetchCategoria(categoria) {
      this.loadingCategoriaSelected = true;
      var componentes = this.categoriasRenderizadas;

      // Elimina los componentes que estan despues del que se va a crear
      for (let index = 0; index < componentes.length; index++) {
        const element = componentes[index];

        if (categoria.mptt_level < element.categoria.level_padre + 1) {
          this.categoriasRenderizadas.splice(index);
        }
      }
      ProductosApi.indexCategorias(categoria.name).then((response) => {
        this.categoriasRenderizadas.push({
          type: ProductoCategoriasTreeBranch,
          categoria: {
            level_padre: response.data.parent.mptt_level,
            categorias: response.data.parent.children,
            nombre_padre: response.data.parent.name,
            id: response.data.parent.id,
          },
        });

        this.loadingCategoriaSelected = false;

        this.$nextTick(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTo({
              left: container.scrollWidth,
              behavior: "smooth",
            });
          }
        });
      });
    },

    loadCategoriasIniciales() {
      this.loadingCategoriaSelected = true;
      const name = this.$route.params.padre;
      console.log(name);

      ProductosApi.indexCategorias(name).then((response) => {
        this.categoriaPadre = response.data.parent;
        this.categoriasRenderizadas.push({
          type: ProductoCategoriasTreeBranch,
          categoria: {
            level_padre: response.data.parent.mptt_level,
            categorias: response.data.parent.children,
            nombre_padre: response.data.parent.name,
            id: response.data.parent.id,
          },
          id: this.count++,
        });
        this.loadingCategoriaSelected = false;
      });
    },
  },
  watch: {
    isDelete(val) {
      if (!val) this.confirmDelete = false;
    },
  },
  created() {
    this.loadCategoriasIniciales();
  },
};
</script>
<style scoped>
.scroll-bar {
  /* align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap; */
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
